/**
 * 画像アップロード（varuna `file/image/upload`）の API クライアント。
 *
 * 画面から axios を生で叩かず、エンドポイント定義と Body の組み立てをここに集約する
 * （CLAUDE.md: HTTP / API Client Constraints, Infra Plugin Access Constraints）。
 *
 * multipart なのは、サーバが画像ファイル本体を multipart でしか受け付けないため
 * （HTTP / API Client Constraints の「バイナリファイル本体」例外）。応答は
 * `data:image/jpeg;base64,…` の data URL で、同じ画像なら毎回同じ文字列が返る。
 */
import axios from 'axios'

const ENDPOINT_PREFIX = process.env.VUE_APP_ENDPOINT_PREFIX || '/'

/** サーバ側の画像変換（リサイズ・回転補正）を含むため長めに取る */
const UPLOAD_TIMEOUT_MS = 40000

/** 画像を送り、data URL を受け取る */
export async function uploadImage(file: File): Promise<string> {
  const formData = new FormData()
  formData.append('image', file)

  const response = await axios.post<string>(
    `${ENDPOINT_PREFIX}file/image/upload`,
    formData,
    {
      headers: { 'content-type': 'multipart/form-data' },
      timeout: UPLOAD_TIMEOUT_MS
    }
  )
  return response.data
}
